import Api from "./api";

import PhpApi from "./phpApi"

export const purchaseApi = new Api("/nftapi/blockchain/deposit");

export const loopBuyVipApi = new Api('/nftapi/match_quiz/getDepositOutCome/','id')

export const getConfigApi = new Api('/nftapi/match_quiz/getStarCoinConfig')

export const getUserSignnatureApi = new PhpApi('/api/customer/createSignatureMsg')

export const createWalletAddressApi = new PhpApi("/api/customer/loginByWalletAddress")